.root {
  align-items: center;
  background: var(--color-secondary);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  color: var(--color-foreground);
  display: inline-flex;
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 12px;
  gap: 8px;
  max-width: 100%;
  padding: 4px 10px;
}

.root-label {
  color: var(--color-muted);
  font-family: var(--font-sans, inherit);
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  white-space: nowrap;
}

.root-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
